import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  topContainer: {padding: 32},
  inputRow: {display: 'flex', gap: '2%', alignItems: 'flex-end'},
};

export default styles;
